import { requestResetPasswordApi } from "@/api/services/main/auth";
import { Button } from "@/components/elements/Button";
import { Form } from "@/components/elements/Form";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { recoverSchema } from "@/features/auth/schema/recoverSchema";
import { TRecoverForm } from "@/features/auth/types/recoverForm";
import { TRecoverQuery } from "@/features/auth/types/recoverQuery";
import { AppRoutes } from "@/routes/config";
import { text } from "@/theme/colors";
import { setErrorForm, showError } from "@/utils/error";
import { getQueryFromURL } from "@/utils/url";
import { yupResolver } from "@hookform/resolvers/yup";
import { Paper, Stack, Typography, styled } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export const RecoverForm = () => {
  const navigate = useNavigate();
  const query = getQueryFromURL<TRecoverQuery>();

  const methods = useForm<TRecoverForm>({
    mode: "onChange",
    defaultValues: { externalId: query?.externalId ?? "" },
    resolver: yupResolver(recoverSchema),
  });
  const { control } = methods;

  const onSubmit = async (data: TRecoverForm) => {
    try {
      await requestResetPasswordApi(data);
      navigate(AppRoutes.recoverComplete, {
        state: { email: data.email, externalId: data.externalId },
      });
    } catch (error) {
      showError(error);
      setErrorForm(methods, error);
    }
  };

  return (
    <Container>
      <Form methods={methods} onSubmit={onSubmit} enableBlocker={false} schema={recoverSchema}>
        <Stack gap="36px" width={400}>
          <Stack gap={4}>
            <Typography variant="head20Bold" color={text.primary} textAlign="center">
              パスワードの再発行
            </Typography>
            <Typography variant="body14" color={text.secondary}>
              組織IDおよび登録済みメールアドレスを入力してください。
            </Typography>
          </Stack>
          <Stack gap={3}>
            <FormField control={control} name="externalId">
              <Input size="lg" placeholder="入力してください" />
            </FormField>
            <FormField control={control} name="email">
              <Input size="lg" placeholder="example@iro-hana.com" />
            </FormField>
          </Stack>
          <Button
            type="submit"
            size="sm"
            variant="primary"
            fullWidth
            sx={{
              mt: "8px",
            }}
          >
            送信
          </Button>
        </Stack>
      </Form>
    </Container>
  );
};

const Container = styled(Paper)`
  border-radius: 12px;
  padding: 24px;
  box-shadow:
    0 4px 4px -1px rgba(12, 12, 13, 0.05),
    0 4px 4px -1px rgba(12, 12, 13, 0.1) !important;
`;
